module.exports = __webpack_public_path__ + "img/nyan-cat.ed012259.gif";